import { Item, User } from '@/api';
import i18next from 'i18next';
import Link from 'next/link';

const ProductTileTitle = ({ data, user }: { data: Item; user: User | null; }) => <h3 className="text-[14px] leading-[21px] cursor-pointer font-[500] line-clamp-2 font-secondary min-h-[41px]"><Link prefetch={false} href={`/item/${data.slug}`}>{(data.private && !user) ? i18next.t('item-text.private-title') : data.name}</Link></h3>;
export default ProductTileTitle;
